 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0246d111":"0606556f","chunk-060770e4":"9a51a0a7","chunk-0c9c8152":"5dd57586","chunk-0dda1fd8":"a7f540b0","chunk-2d627f1c":"2164d25e","chunk-3bb30c76":"b64dc3fb","chunk-6c224edc":"36df5892","chunk-6d0f4e0f":"ed32613c","chunk-e9f822c4":"2f5b5f56","chunk-5ee609b3":"ac506e82","chunk-710eb8de":"06c4d995","chunk-0dfa511e":"bdd8db46","chunk-21672af4":"39170a6d","chunk-0bf78c84":"639f2a9e","chunk-28429d0b":"c7e54c14","chunk-31743c23":"fcccbfed","chunk-f15a7346":"3fdcd50a","chunk-256a16be":"2f3f501a","chunk-2ab3c2ac":"2b85687d","chunk-2d0c4303":"859bb668","chunk-2d225628":"32a1232c","chunk-2d22c303":"d1493813","chunk-219f599c":"a70ed624","chunk-41547722":"eb41d79b","chunk-49fe6bb4":"37b74d68","chunk-4b8b016e":"b13b5ff8","chunk-505cd403":"e986e1e5","chunk-54d50591":"b6498a08","chunk-54fc824c":"4dd28ed5","chunk-5bb3756f":"9b7a3d17","chunk-5e1f87af":"f1105735","chunk-7004a2b9":"7e3d5d72","chunk-13fa30e4":"160cc970","chunk-3762e432":"082e9f71","chunk-8bf1324e":"ba259f7f","chunk-aa863330":"5d76b20a","chunk-bf7654c2":"a67f8750","chunk-c1bdf2c0":"bf58a0ed","chunk-f64d59ba":"b14d1b35","chunk-f7ee557a":"f55ebc6e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0246d111":1,"chunk-060770e4":1,"chunk-0c9c8152":1,"chunk-3bb30c76":1,"chunk-6c224edc":1,"chunk-6d0f4e0f":1,"chunk-e9f822c4":1,"chunk-5ee609b3":1,"chunk-710eb8de":1,"chunk-0dfa511e":1,"chunk-0bf78c84":1,"chunk-28429d0b":1,"chunk-31743c23":1,"chunk-f15a7346":1,"chunk-256a16be":1,"chunk-2ab3c2ac":1,"chunk-219f599c":1,"chunk-41547722":1,"chunk-49fe6bb4":1,"chunk-505cd403":1,"chunk-54d50591":1,"chunk-54fc824c":1,"chunk-5bb3756f":1,"chunk-5e1f87af":1,"chunk-13fa30e4":1,"chunk-3762e432":1,"chunk-8bf1324e":1,"chunk-aa863330":1,"chunk-bf7654c2":1,"chunk-f64d59ba":1,"chunk-f7ee557a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0246d111":"b9369601","chunk-060770e4":"e7eab797","chunk-0c9c8152":"73d7926d","chunk-0dda1fd8":"31d6cfe0","chunk-2d627f1c":"31d6cfe0","chunk-3bb30c76":"b83ff88f","chunk-6c224edc":"38cf3ca5","chunk-6d0f4e0f":"cadd91c0","chunk-e9f822c4":"ba6c02c7","chunk-5ee609b3":"bbce0bd0","chunk-710eb8de":"bbce0bd0","chunk-0dfa511e":"0500cd9c","chunk-21672af4":"31d6cfe0","chunk-0bf78c84":"064618c2","chunk-28429d0b":"f070fc16","chunk-31743c23":"9a98ed31","chunk-f15a7346":"b4c90350","chunk-256a16be":"eca29ec6","chunk-2ab3c2ac":"1cd5f016","chunk-2d0c4303":"31d6cfe0","chunk-2d225628":"31d6cfe0","chunk-2d22c303":"31d6cfe0","chunk-219f599c":"2bbd46d9","chunk-41547722":"cff0130e","chunk-49fe6bb4":"c05ffdc4","chunk-4b8b016e":"31d6cfe0","chunk-505cd403":"7d3dbcc8","chunk-54d50591":"c581f2bb","chunk-54fc824c":"383e901c","chunk-5bb3756f":"3ee6a2fb","chunk-5e1f87af":"9e84cf74","chunk-7004a2b9":"31d6cfe0","chunk-13fa30e4":"66807e5f","chunk-3762e432":"b6d2bccf","chunk-8bf1324e":"f4ffa815","chunk-aa863330":"6b51a8d8","chunk-bf7654c2":"1d9e5586","chunk-c1bdf2c0":"31d6cfe0","chunk-f64d59ba":"67907a5d","chunk-f7ee557a":"2dd6acff"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/nutritionist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
